module.exports = __webpack_public_path__ + "static/takedaImg1-ee8a55a13d012d67e41f448494213e7d.jpg";